import React, { Component } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router';
import {
  userChartDelete,
  userChartEdit,
  userChartGet,
} from '../requests/UserChart';
import NewDashboardModal from '../layout/NewDashboardModal';
import DashboardFolderModal from '../layout/DashboardFolderModal';
import {
  CheckOutlined,
  CloseOutlined,
  ControlTwoTone,
  DeleteOutlined,
  DeleteTwoTone,
  EditTwoTone,
  HeartTwoTone,
  SaveTwoTone,
} from '@ant-design/icons';

import {
  Button,
  Col,
  Divider,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Row,
  Typography,
} from 'antd';
import {
  folderEdit,
  folderGetByDashboardByUser,
  folderGetByLevelByUser,
} from '../requests/Folder';
import { userEdit, userGetByEmail } from '../requests/User';
import { connect } from 'react-redux';
import { updateFolder } from '../../action/action';
import { generateURL } from '../requests/LookerURLRoute';
import { AppContext } from '../libs/ContextLibs';

const { confirm } = Modal;
const { Title } = Typography;
const InputGroup = Input.Group;

class Dashboard extends Component {
  static contextType = AppContext;

  item = {
    _id: '',
    user_id: '',
    title: '',
    dashboard_id: '',
    object: null,
    active: true,
    subscription_plan_id: '',
    user_created: false,
    override_filters: false,
  };

  toggle() {
    this.setState((state) => ({
      collapse: !state.collapse,
    }));
  }

  constructor(props) {
    super(props);
    this.state = {
      dashboardID: this.props.params.id,
      item: this.item,
      collapse: false,
      currentUserName: '',
      random: 0,
      url: '',
      title: '',
      isDashboardTitleUpdate: false,
      modal1Click: false,
      modal2Click: false,
    };
    this.setDefaultDashboard = this.setDefaultDashboard.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleTitleUpdate = this.handleTitleUpdate.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.saveItem = this.saveItem.bind(this);
    this.handleFrameTasks = this.handleFrameTasks.bind(this);
    this.handleSaveDashboardAlert = this.handleSaveDashboardAlert.bind(this);
    this.handleSaveDashboardError = this.handleSaveDashboardError.bind(this);
    this.deleteDashboard = this.deleteDashboard.bind(this);
  }

  setDefaultDashboard() {
    if (this.context.user && this.context.user.username) {
      userGetByEmail(this.context.user.username, (r2) => {
        const item = { ...r2, default_chart: this.state.dashboardID };
        userEdit(item, (response) => {
          message.success('Homepage dashboard set to current dashboard.', 2);
        });
      });
    }
  }

  handleFrameTasks = (event) => {
    let iframe = document.getElementById('looker');
    let iframeDiv = document.getElementById('looker_div');
    if (event.source === iframe.contentWindow) {
      let lookerData;
      try {
      lookerData = JSON.parse(event.data);
    } catch (error) {
      console.warn('Failed to parse event data as JSON');
      return; // Skip if parsing fails
    }
      if (event.origin === window.appConfig.lookerUrl) {
        let item = { ...this.state.item };
        if (
          lookerData.type === 'dashboard:filters:changed' ||
          lookerData.type === 'dashboard:run:complete'
        ) {
          item.object = lookerData.dashboard;
          this.setState({ item: item });
        }
      }
      if (
        lookerData.type === 'page:properties:changed' ||
        lookerData.type === 'drillmenu:click'
      ) {
        //Dynamically set the iFrame height everytime the page is updated
        iframe.style.height = lookerData.height + 'px';
        iframeDiv.style.height = lookerData.height + 'px';
      }
    }
  };

  handleSaveDashboardAlert(value) {
    message.success('Dashboard saved successfully.', 2);
  }

  handleSaveDashboardError(value) {
    message.error('Error saving dashboard. Please notify an admin.', 2);
  }

  handleTitleChange(event) {
    const target = event.target;
    let value = target.value;
    let item = { ...this.state.item };
    item.title = value;
    this.setState({
      item: item,
    });
  }

  handleTitleUpdate() {
    this.saveItem().then(() => {
      this.setState({ isDashboardTitleUpdate: true });
      this.toggle();
      this.updateDashboard();
    });
  }

  updateDashboard = () => {
    if (this.context?.user?.username) {
      folderGetByLevelByUser(this.context.user.username, 0, (response) => {
        this.props.updateFolder(response);
      });
    }
  };

  handleFilterChange() {
    let { item } = this.state;
    item.override_filters = true;
    this.setState({ item: item });
    this.saveItem().then(() => {
      message.success('Filters saved successfully.', 2);
    });
  }

  async saveItem() {
    let { item } = this.state;
    userChartEdit(item, (response) => {
      this.setState({ item: response });
    });
  }

  deleteDashboard = () => {
    confirm({
      title: 'Delete dashboard ' + this.state.item.title + '?',
      content: 'You will be redirected to your home page after deletion.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => {
        let dashboardFolder = null;
        folderGetByDashboardByUser(
          this.context.user?.username,
          this.state.dashboardID,
          (response) => {
            dashboardFolder = response;
            var index = dashboardFolder.charts.indexOf(this.state.dashboardID);
            if (index > -1) {
              dashboardFolder.charts.splice(index, 1);
            }
            folderEdit(dashboardFolder, () => {
              userChartDelete(this.state.dashboardID, () => {
                this.updateDashboard();
                this.props.navigate('/');
              });
            });
          }
        );
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  componentDidMount() {
    if (this.context.user && this.context.user?.username) {
      this.setState({ currentUserName: this.context.user?.username });
    }
    if (
      this.props.location.state !== undefined &&
      this.props.location.state !== null &&
      this.props.location.state.item
    ) {
      document.title =
        this.props.location.state.item.title + ' - Insights Portal, NielsenIQ';
      this.setState({
        item: this.props.location.state.item,
        url: this.props.location.state.url,
      });
      window.addEventListener('message', this.handleFrameTasks);
    } else {
      userChartGet(this.props.params.id, (response) => {
        document.title = response.title + ' - Insights Portal, NielsenIQ';
        if (this.context.user && this.context.user?.username) {
          userGetByEmail(this.context.user?.username, (r2) => {
            generateURL(response, r2, (url) => {
              this.setState({ item: response, url: url });
            }, (error) => {
              console.error('Error generating URL:', error);
            });
          });
        }
        window.addEventListener('message', this.handleFrameTasks);
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.params.id !== this.props.params.id) {
      window.removeEventListener('message', this.handleFrameTasks);
      this.setState({ dashboardID: this.props.params.id });
      this.componentDidMount();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.params.id !== prevState.dashboardID) {
      return { dashboardID: nextProps.params.id };
    } else return null;
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks);
  }

  render() {
    const { url, item, dashboardID } = this.state;
    const deleteMenu =
      item.user_created === true ? (
        <Menu.Item key='5' onClick={this.deleteDashboard}>
          <span>
            <DeleteTwoTone />
            Delete dashboard
          </span>
        </Menu.Item>
      ) : (
        <Menu.Item key='5' disabled>
          <span>
            <DeleteOutlined />
            Delete dashboard
          </span>
        </Menu.Item>
      );
    const menu = (
      <Menu>
        <Menu.Item key='6' onClick={this.setDefaultDashboard}>
          <span>
            <HeartTwoTone />
            Set homepage dashboard
          </span>
        </Menu.Item>
        <Menu.Item key='1' onClick={this.toggle}>
          <span>
            <EditTwoTone />
            Edit dashboard name
          </span>
        </Menu.Item>
        <Menu.Item key='2' onClick={this.handleFilterChange}>
          <span>
            <SaveTwoTone />
            Save filters as default
          </span>
        </Menu.Item>
        <Menu.Item key='3'>
          <NewDashboardModal
            key='key_dashboardId'
            dashboardID={dashboardID}
            userName={this.context.user?.username}
            item={item}
            onSuccess={this.handleSaveDashboardAlert}
            onError={this.handleSaveDashboardError}
          />
        </Menu.Item>
        <Menu.Item key='4'>
          <DashboardFolderModal
            key='Key_dashboardModelId'
            dashboardID={dashboardID}
            userName={this.context.user?.username}
            onSuccess={this.handleSaveDashboardAlert}
            onError={this.handleSaveDashboardError}
          />
        </Menu.Item>
        {deleteMenu}
      </Menu>
    );

    return (
      <div style={{ background: '#fff', padding: 24, minHeight: 280 }}>
        <div>
          <Row>
            <Col span={23}>
              {!this.state.collapse ? (
                <Title level={4}>{item.title}</Title>
              ) : (
                <InputGroup compact>
                  <Input
                    autoFocus
                    style={{ width: '80%' }}
                    name='title'
                    id='title'
                    defaultValue={item.title || ''}
                    onChange={this.handleTitleChange}
                    onPressEnter={this.handleTitleUpdate}
                  />
                  <Button type='primary' danger onClick={this.toggle}>
                    <CloseOutlined />
                  </Button>
                  <Button
                    type='primary'
                    title='Update Dashboard'
                    onClick={this.handleTitleUpdate}
                  >
                    <CheckOutlined />
                  </Button>
                </InputGroup>
              )}
            </Col>
            <Col style={{ textAlign: 'center' }} span={1}>
              <Title level={4}>
                <Dropdown overlay={menu}>
                  <span style={{ userSelect: 'none' }}>
                    <ControlTwoTone title='Menu' />
                  </span>
                </Dropdown>
              </Title>
            </Col>
          </Row>
        </div>

        <Divider />

        <div
          id={'looker_div'}
          className='embed-responsive embed-responsive-4by3'
        >
          <iframe
            id={'looker'}
            title={'Dashboard'}
            className='embed-responsive-iframe'
            src={url}
          ></iframe>
        </div>
      </div>
    );
  }
}

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  }
  return ComponentWithRouterProp;
}

export default withRouter(connect(null, { updateFolder })(Dashboard));
